import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://zahnarzt-st-toenis.de';
const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;

const SEO = ({ title, description, path = '/', image = DEFAULT_IMAGE, noindex = false, jsonLd }) => {
    const url = `${SITE_URL}${path}`;
    const jsonLdList = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />
            {noindex && <meta name="robots" content="noindex, nofollow" />}

            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Zahnarztpraxis Roman Boretskyi" />
            <meta property="og:locale" content="de_DE" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={image} />

            <meta name="twitter:card" content="summary" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />

            {jsonLdList.map((schema, index) => (
                <script key={index} type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            ))}
        </Helmet>
    );
};

export default SEO;
